var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7344 17.4741H18.5533V2.78125C18.5533 2.34973 18.2036 2 17.772 2H5.26562C4.83411 2 4.48438 2.34973 4.48438 2.78125V18.2553C4.48438 20.3202 6.16376 22 8.22797 22H17.772C19.8362 22 21.5156 20.3202 21.5156 18.2553C21.5156 17.824 21.1659 17.4741 20.7344 17.4741ZM10.4091 18.2553C10.4091 19.4586 9.43066 20.4375 8.22797 20.4375C7.02527 20.4375 6.04688 19.4586 6.04688 18.2553V3.5625H16.9908V17.4741H11.1903C10.7588 17.4741 10.4091 17.824 10.4091 18.2553ZM17.772 20.4375H11.2686C11.5652 20.0251 11.7802 19.5502 11.8896 19.0366H19.8086C19.4938 19.8551 18.6996 20.4375 17.772 20.4375ZM15.8157 6.64844C15.8157 7.07996 15.466 7.42969 15.0345 7.42969H8.0032C7.57169 7.42969 7.22195 7.07996 7.22195 6.64844C7.22195 6.21692 7.57169 5.86719 8.0032 5.86719H15.0345C15.466 5.86719 15.8157 6.21692 15.8157 6.64844ZM15.8157 10.5156C15.8157 10.9471 15.466 11.2969 15.0345 11.2969H8.0032C7.57169 11.2969 7.22195 10.9471 7.22195 10.5156C7.22195 10.0841 7.57169 9.73438 8.0032 9.73438H15.0345C15.466 9.73438 15.8157 10.0841 15.8157 10.5156ZM15.8157 14.3828C15.8157 14.8143 15.466 15.1641 15.0345 15.1641H8.0032C7.57169 15.1641 7.22195 14.8143 7.22195 14.3828C7.22195 13.9513 7.57169 13.6016 8.0032 13.6016H15.0345C15.466 13.6016 15.8157 13.9513 15.8157 14.3828Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsent);
export default __webpack_public_path__ + "static/media/consent.216b66588a518b06fda0ee0bc6e89036.svg";
export { ForwardRef as ReactComponent };